module.exports = __webpack_public_path__ + "img/cake-10.889230ea.svg";